<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-column" scrollable centered button-size="sm" no-close-on-esc>
      <template #modal-title>
        <i class="fas fa-money-check-dollar"></i> Controle de despesas
      </template>
      <div class="form-group row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h5><i class="fas fa-columns"></i> Despesas</h5>
            </div>
            <div>
              <button type="button" class="btn btn-third btn-sm" @click="onAdd">
                <i class="fas fa-plus-circle"></i> Adicionar
              </button>
            </div>
          </div>
          <div v-for="(despesa, index) in listOfDespesas" :key="index + 'despesa'"
            class="column-configuration pointer accordion accordion-flush flex-column" id="accordion-despesas-list">
            <div class="d-flex align-items-center accordion row" role="tablist">
              <span style="cursor:pointer" @click="onRemove(despesa.id)" class="col-md-1 col-1"><i
                  class="fas fa-trash text-danger pl-1"></i></span>
              <div class="input-group col-md-4 col-4">
                <money id="valor-despesa" :placeholder="$lang.Currency.Placeholder" class="form-control text-bold"
                  max-length="12" style="text-align: right;padding-left: 4px;" :value="despesa.valor"
                  v-model.lazy="despesa.valor" v-bind="$lang.Currency.Format"></money>
              </div>
              <div class="input-group col-md-6 pt-3">
                <b-form-select v-model="despesa.idDespesa" :options="expenseOptions" @change="onChangeOption(despesa)" class="mb-3" >
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
              <span style="cursor:pointer" v-b-toggle="'accordion-' + index" :style="'margin-left: -5px;'"
                class="col-md-1 mt-md-0 mt-1 pb-1 mr-1 d-flex justify-content-center align-items-center">
                <i class="fas fa-caret-down" style="font-size:25px"></i>
              </span>
            </div>
            <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel" class="row w-100">
              <div class="pt-2">
                <label for="txtDetalhes"> Observações:</label>
                <b-form-textarea id="txtDetalhes" name="txtDetalhes" v-model="despesa.observacao"
                  :placeholder="'Digite as observações da despesa aqui'" :rows="3" :size="'280'"
                  :noResize="true"></b-form-textarea>
              </div>
            </b-collapse>
          </div>
          <div v-if="listOfDespesas.length !== 0" class="form-group row">
            <div class="col-md-12 pt-2">
              <label><small v-show="expectedAttachments" class="text-danger">*</small> Anexo:</label>
              <div class="input-group pb-2" v-for="(file, index) in files" :key="index">
                <div class="d-flex bg-third px-2 py-1 rounded">
                  <div class="d-inline-block text-truncate">
                    <span>{{ file.name }} &nbsp;</span>
                  </div>
                  <button @click="onDeleteFile(file)" class="rotate-hover-icon exclude-file-button">
                    <i class="fas fa-times text-danger"></i>
                  </button>
                </div>
              </div>
              <div class="input-group" @drop="onUploadDrop" @dragover="onUploadDragover">
                <div class="upload" style="cursor: pointer;" @click="onUploadClick">
                  <input multiple type="file" ref="inputFile" v-show="false" accept="*" @change="onFileChange" />
                  <div><i class="fas fa-file-import" style="font-size: 17px"></i></div>
                  <span>Clique ou arraste aqui para anexar!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Salvar'" @click="onSaveDespesa">
            <i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import DespesasModal from './despesas.js'
export default DespesasModal
</script>

<style scoped>
#txtDetalhes,
#valor-despesa {
  border-radius: 5px;
}

.exclude-file-button {
  background-color: transparent;
  border-style: none;
  outline: none;
}

.upload {
  border: solid 1px #ccc;
  border-radius: 4px;
  background-color: #efefef;
  padding: 3%;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/UI/despesasModal/despesas.vue